import React, {useRef, useState} from 'react';
import {useCheckoutContext} from "../../../../contexts/CheckoutContext";
import {is3dsPaymentMethod} from "../PaymentDetails/helpers";
import StepUpIframe from "../PaymentDetails/CreditCard/ThreeDSecure/StepUpIframe/stepUpIframe";
import * as styles from "../style.module.css";
import SectionHeader from "../sectionHeader";
import {SectionContent} from "./sectionContent";
import Submit from "./submit";
import {MyAccountForm} from "./myAccountForm";

export const CODE = 'review';
export const TITLE = 'Order review';

export default function Review({step, cartData}) {
    const [checkout] = useCheckoutContext();
    const isActive = checkout.activeStep===step;

    const [cache, setCache] = useState({
        additional_uploads: [],
        ont_additional_confirmation_emails: '',
        is_confirmation_emails_valid: false,
    });

    const isQuotation = checkout.redeemQuote ?? false;

    const method = checkout.payment_method?.selected_payment_method;
    const is3dsMethod = is3dsPaymentMethod(method);

    const stepUpIframeRef = useRef(null);
    const stepUpOverlayRef = useRef(null);

    const openStepUpIframe = (challengeWindowSize = '02') => {
        const iframe = stepUpIframeRef.current;
        const dimensions = {
            '01': ['260px', '410px'],
            '02': ['400px', '410px'],
            '03': ['510px', '610px'],
            '04': ['610px', '410px'],
        }
        const [width, height] = dimensions[challengeWindowSize] ?? ['250px', '400px'];

        iframe.height = height;
        iframe.width = width;
        stepUpOverlayRef.current.style.display = 'block';
        iframe.style.display = 'block';
    }
    const closeStepUpIframe = () => {
        stepUpIframeRef.current.style.display = 'none';
        stepUpOverlayRef.current.style.display = 'none';
    }

    return <div className={styles.section}>
        <SectionHeader step={step} code={CODE} title={TITLE} />
        {is3dsMethod && <StepUpIframe iframeRef={stepUpIframeRef} overlayRef={stepUpOverlayRef} />}

        {isActive && <>
            <SectionContent cache={cache} setCache={setCache} cartData={cartData}/>
            <Submit
                cache={cache}
                isQuotation={isQuotation}
                openStepUpIframe={openStepUpIframe}
                closeStepUpIframe={closeStepUpIframe}
            />

            {/*{isMyAccountPayment &&*/}
            {/*    <MyAccountForm*/}
            {/*        orderNumber={orderNumber}*/}
            {/*        cartData={cartData}*/}
            {/*        formRef={myAccountFormRef}*/}
            {/*    />*/}
            {/*}*/}
        </>}
    </div>;
}
